export default __webpack_public_path__ + "static/media/140.a59a3fa3.jpg";